import { Component, Input, ViewEncapsulation, SimpleChanges, Output, EventEmitter, OnInit, AfterViewInit } from '@angular/core';
import Swal, { SweetAlertInput } from 'sweetalert2';
import { CommonService } from './../../service/common/common.service';
import { Router } from '@angular/router';
import { AuthService } from '../../service/auth/auth.service';
// import { sliceEventStore } from '@fullcalendar/core/internal';

@Component({
  selector: 'app-register-number-email',
  templateUrl: './register-number-email.component.html',
  styleUrls: ['./register-number-email.component.css'],
  encapsulation: ViewEncapsulation.None,
})
export class RegisterNumberEmailComponent implements OnInit, AfterViewInit {
  @Input() isModalOpen: boolean = false;
  @Output() modalClosed = new EventEmitter<boolean>();
  steps = ['1', '2', '3'];
  private modalOpened = false;

  constructor(
    private readonly commonService: CommonService,
    private readonly router: Router,
    private readonly authService: AuthService,
  ) {
    // do nothing
  }

  ngOnInit() {
    // do nothing
  }

  ngAfterViewInit() {
    setTimeout(() => {
      if (this.isModalOpen && !this.modalOpened) {
        this.modalOpened = true;
        this.showAlert();
      }
    }, 500);
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['isModalOpen'] && changes['isModalOpen'].currentValue === true && !this.modalOpened) {
      this.modalOpened = true;
      this.showAlert();
    }
  }

  openModal() {
    if (!this.modalOpened) {
      this.modalOpened = true;
      this.showAlert();
    }
  }

  swalQueueStep = Swal.mixin({
    confirmButtonText: 'Siguiente →',
    showCancelButton: true,
    progressSteps: this.steps,
    padding: '2em',
    customClass: {
      popup: 'sweet-alerts',
      confirmButton: 'btn-custom',
    },
  });

  async showAlert(value?: number) {
    console.log(value);
    const stepsData: any[] = [
      {
        title: '¡Inicia sesión en solo 3 pasos! 🚀',
        text: 'Elige cómo deseas iniciar sesión: con tu número de teléfono o tu correo electrónico.',
        input: 'select' as SweetAlertInput,
        inputOptions: {
          phone: 'Número de teléfono',
        },
        inputPlaceholder: 'Selecciona una opción',
        showCancelButton: true,
        inputValidator: (value: string) => {
          if (!value) {
            return 'Debes seleccionar una opción 🚨';
          }
          return null;
        },
      },
      {
        title: 'Ingresa tu dato 📩',
        input: 'text' as const,
        inputPlaceholder: 'Ej: +57 123 456 789 o usuario@gmail.com',
      },
      {
        title: 'Código de verificación 🔐',
        text: 'Hemos enviado un código de 6 dígitos. Ingrésalo aquí:',
        input: 'text' as const,
        inputAttributes: { maxlength: '6', pattern: '[0-9]{6}', required: 'true' },
      },
    ];

    let userChoice = '';

    try {
      // PASO 1: Selección entre teléfono o correo
      const step1 = await this.swalQueueStep.fire({ ...stepsData[0], currentProgressStep: 0 });
      if (step1.isDismissed) {
        this.modalOpened = false;
        this.modalClosed.emit(true);
        return;
      }
      if (!step1.value) return;
      userChoice = step1.value;

      // PASO 2: Ingreso del dato
      stepsData[1].title = `Ingresa tu ${userChoice === 'phone' ? 'número de teléfono' : 'correo electrónico'} 📩`;
      stepsData[1].input = userChoice === 'phone' ? ('tel' as const) : ('email' as const);
      stepsData[1].inputPlaceholder = userChoice === 'phone' ? 'Ej: +57 123 456 789' : 'Ej: usuario@gmail.com';

      const step2 = await this.swalQueueStep.fire({ ...stepsData[1], currentProgressStep: 1 });
      if (step2.isDismissed) {
        this.modalOpened = false;
        this.modalClosed.emit(true);
        return;
      }
      if (!step2.value) return;
      const userInput = step2.value;

      const response = await this.commonService.sendSmsCode({
        email: userInput,
        phone: {
          code: '+57',
          number: userInput,
        },
      });

      if (response.code.code === 'PTZ0000') {
        // PASO 3: Código de verificación
        const step3 = await this.swalQueueStep.fire({ ...stepsData[2], currentProgressStep: 2 });
        if (step3.isDismissed) {
          this.modalOpened = false;
          this.modalClosed.emit(true);
          return;
        }
        if (!step3.value) return;

        const response = await this.commonService.login({
          email: userInput,
          password: step3.value,
        });

        if (response.code.code === 'PTZ0000') {
          await Swal.fire({
            toast: true,
            title: 'inicio de sesión con éxito! 🎉',
            text: 'Ahora puedes disfrutar de nuestros servicios.',
            icon: 'success',
            confirmButtonText: 'Aceptar',
            customClass: { popup: 'sweet-alerts' },
          });

          localStorage.setItem('secTkn', response.data.access_token);
          this.authService.setAuthenticated(true);
          this.router.navigate(['/profile']);

          this.modalOpened = false;
          this.modalClosed.emit(true);
        }
      }
    } catch (error) {
      console.error('Error en el proceso de registro:', error);
      this.modalOpened = false;
      this.modalClosed.emit(true);
    }
  }
}
